import React from 'react';
import { useBulleAuSurvol } from './BulleSurvol';

/**
 * Un en-tête de colonne qui explique sa métrique au survol.
 *
 * ## Pourquoi un composant plutôt que le hook posé dans chaque tableau
 *
 * La bulle sort par un portail, et doit donc être rendue quelque part dans l'arbre de celui qui
 * la déclenche. Dans un tableau, ce « quelque part » n'existe pas naturellement : entre
 * `<thead>` et `<tr>` il n'y a aucun endroit neutre où glisser une ligne de JSX, et les neuf
 * tableaux Meta n'ont pas la même structure. En faisant de l'en-tête lui-même le porteur, le
 * problème disparaît — la bulle est son enfant.
 *
 * ## Pourquoi pas l'attribut `title`
 *
 * Il était posé et ne sortait pas : le navigateur attend une à deux secondes, et sur une
 * cellule que le pointeur traverse, l'infobulle n'apparaît jamais. C'est le même constat
 * qu'au tableau Analytics de l'accueil, qui a abandonné `title` pour cette raison.
 *
 * `texte` vide rend un `<th>` ordinaire : on câble une colonne sans savoir si elle aura
 * quelque chose à dire.
 */
const EnteteAvecBulle = ({ texte, children, ...proprietes }) => {
  const { survoler, quitter, bulle } = useBulleAuSurvol();

  return (
    <th
      {...proprietes}
      style={texte ? { cursor: 'help', ...proprietes.style } : proprietes.style}
      onMouseEnter={survoler(texte)}
      onMouseLeave={quitter}
    >
      {children}
      {bulle}
    </th>
  );
};

export default EnteteAvecBulle;
